/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { VerificationRequestDto } from '../../models/verification-request-dto';
import { VerificationRequestResponse } from '../../models/verification-request-response';

export interface VerificationRequest$Params {
      body: VerificationRequestDto
}

export function verificationRequest(http: HttpClient, rootUrl: string, params: VerificationRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<VerificationRequestResponse>> {
  const rb = new RequestBuilder(rootUrl, verificationRequest.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VerificationRequestResponse>;
    })
  );
}

verificationRequest.PATH = '/api/v1/verification-request';
